/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  tabPanel: Item<'TabPanel'>;
  tabItem: Item<'TabItem'>;
  tabItem1: Item<'TabItem'>;
  tabItem2: Item<'TabItem'>;
  tabItem3: Item<'TabItem'>;
  tabItem4: Item<'TabItem'>;
  tabItem5: Item<'TabItem'>;
} = {
  root: {
    children: ['tabPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  tabItem: {
    children: [],
    itemId: 'tabItem',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: 'analytics',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Tab One',
      },
    },
    type: 'TabItem',
  },
  tabItem1: {
    children: [],
    itemId: 'tabItem1',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: 'apple',
        iconType: 'brands',
      },
      label: {
        type: 'text',
        value: 'Tab Two',
      },
    },
    type: 'TabItem',
  },
  tabItem2: {
    children: [],
    itemId: 'tabItem2',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: 'edit',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Tab Three',
      },
    },
    type: 'TabItem',
  },
  tabPanel: {
    children: ['tabItem', 'tabItem1', 'tabItem2'],
    itemId: 'tabPanel',
    parent: 'root',
    props: {},
    type: 'TabPanel',
  },
  tabItem3: {
    children: [],
    itemId: 'tabItem3',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: '',
      },
      label: {
        type: 'text',
        value: 'Tab One',
      },
    },
    type: 'TabItem',
  },
  tabItem4: {
    children: [],
    itemId: 'tabItem4',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: '',
      },
      label: {
        type: 'text',
        value: 'Tab Two',
      },
    },
    type: 'TabItem',
  },
  tabItem5: {
    children: [],
    itemId: 'tabItem5',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: '',
      },
      label: {
        type: 'text',
        value: 'Tab Three',
      },
    },
    type: 'TabItem',
  },
};
